const apiUtilsSmsmedia = {
    baseUrl: "https://smsmediaapi.hellopatna.com", // Base URL of your API
    //baseUrl: "http://192.168.31.121:7265", // Base URL of your API

    // Function to get headers
    getHeaders: function () {
        return {
            "X-Api-Key": localStorage.getItem("smsmediaApiKey"), // Retrieve API key from localStorage
            "Content-Type": "application/json",
        };
    },

    // Generalized API call function
    callApi: async function (endpoint, method = "GET", data = null, params = {}, isMultipart = false) {
        try {
            params = params || {}; // Ensure params is always an object

            if (typeof window.showWaitDialog === "function") {
                window.showWaitDialog("Please wait...");
            }

            const url = new URL(`${this.baseUrl}${endpoint}`);

            // Append query parameters
            Object.keys(params).forEach((key) => url.searchParams.append(key, params[key]));

            // Configure headers
            const headers = this.getHeaders();
            if (isMultipart) {
                delete headers["Content-Type"]; // Let the browser set the Content-Type for FormData
            }

            // Configure fetch options
            const fetchOptions = {
                method: method,
                headers: headers,
                body: data instanceof FormData ? data : data ? JSON.stringify(data) : null,
            };

            const response = await fetch(url, fetchOptions);

            console.log("Response Status:", response.status);

            // Read response based on Content-Type
            const contentType = response.headers.get("Content-Type") || "";
            let result;
            if (contentType.includes("application/json")) {
                result = await response.json();
            } else {
                result = await response.text();
            }

            if (!response.ok) {
                throw new Error(result || `HTTP error ${response.status}`);
            }
            return result;
        } catch (error) {
            console.error("Error in API Call:", error);
            throw error;
        } finally {
            if (typeof window.hideWaitDialog === "function") {
                window.hideWaitDialog();
            }
        }
    },

    handleError: function (error, userMessage = "An error occurred. Please try again.", notificationFn = null) {
        try {
            const errorMessage = error.message || "An unknown error occurred.";
            const fullMessage = userMessage + " " + errorMessage;
            
            // Try to use the provided notification function first
            if (notificationFn && typeof notificationFn === 'function') {
                notificationFn(fullMessage);
            }
            // Fallback to console.error
            else {
                console.error("API Error:", fullMessage);
                // If window has a global notification system, try to use it
                if (window.showError && typeof window.showError === 'function') {
                    window.showError(fullMessage);
                }
            }
        } catch (e) {
            console.error("Error in handleError:", e);
            const fallbackMessage = userMessage || "An error occurred. Please try again.";
            
            if (notificationFn && typeof notificationFn === 'function') {
                notificationFn(fallbackMessage);
            } else {
                console.error("API Error:", fallbackMessage);
                if (window.showError && typeof window.showError === 'function') {
                    window.showError(fallbackMessage);
                }
            }
        }
    },
};

export default apiUtilsSmsmedia;
